import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CompletedEPTourContent } from '../../../../redux/sagas/types';
import { ORDER_TYPE_COMMERCIAL_EP } from '../../../../constants';
import { determineIconByOrderType, displayDate } from '../../../../utils';
import styles from './CompletedEPTourList.css';

type Props = {
  completedTour: CompletedEPTourContent;
  reprintLabels: (data: CompletedEPTourContent) => void;
};

const CompletedEPItem = ({ completedTour, reprintLabels }: Props): ReactElement => {
  const { t } = useTranslation();
  const translationRoot = 'ORDER_LIST.LIST_ITEM';
  const { createTS, metadata } = completedTour;
  const { totalItemsPicked, totalItems, ordersSummaryData = [] } = metadata || {};
  const pickTourDestination = ordersSummaryData?.[0]?.destination ?? null;

  const handleReprintClick = (event: React.MouseEvent) => {
    // Stop event propagation to prevent accordion toggle
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const { pickTourList } = completedTour;
    reprintLabels({
      ...completedTour,
      pickTourList: pickTourList.filter(pickTourItem => pickTourItem.pickedItemQuantity > 0),
    });
  };
  const formattedDate = displayDate({ date: createTS }) || '';
  const [datePart = '', timePart = ''] = formattedDate.split('-');

  const ReprintButton = () => (
    <div className={styles.reprintLabels}>
      {totalItemsPicked ? (
        <button type="button" onClick={handleReprintClick} aria-label={t(`${translationRoot}.REPRINT_ALL_LABELS`)}>
          {t(`${translationRoot}.REPRINT_ALL_LABELS`)}
        </button>
      ) : (
        <span>{t(`${translationRoot}.SKIPPED`)}</span>
      )}
    </div>
  );

  return (
    <div className={styles.mainArea}>
      <div className={styles.destination}>{pickTourDestination}</div>
      <div className={styles.content}>
        <div className={styles.orderType}>
          <div className={styles.icon}>{determineIconByOrderType({ orderType: ORDER_TYPE_COMMERCIAL_EP })}</div>
          <p>{t('UTILS.COMMERCIALEP')}</p>
        </div>
        <ReprintButton />
        <div className={styles.tourMetaInfo}>
          <div className={styles.itemsInfo}>
            <div className={styles.itemsQuantity}>
              <span>{t(`${translationRoot}.TOTAL_PIECES`)}</span>
              <span className={styles.quantity}>
                {totalItemsPicked} / {totalItems}
              </span>
            </div>
            <div className={styles.itemsPick}>
              <span className={styles.textLight}>{datePart}</span>
              <span className={styles.orderTime}>{timePart}</span>
            </div>
          </div>
          <ReprintButton />
        </div>
      </div>
    </div>
  );
};

export default CompletedEPItem;
